import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse
} from "../../APIHelpers/Responses";

export const propertyServices = {
  addNewProperty,
  updatedProperty,
  deleteProperty,
  getPropertyList,
  getAccessPropertyList,
  getSingleProperty
};

// Add New Property
async function addNewProperty(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewProperty`,
    headersWithAuth("POST", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Update Property
async function updatedProperty(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedProperty`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Property
async function deleteProperty(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteProperty`,
    headersWithAuth("DELETE", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get All Property
async function getPropertyList(accountId, status) {
  try {
    const signal = cancelPreviousRequest(`getPropertyList`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getPropertyList/${accountId}/${status}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if(data?.statusCode === 401){
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Access Property
async function getAccessPropertyList() {
  try {
    const signal = cancelPreviousRequest(`getAccessPropertyList`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getAccessPropertyList`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if(data?.statusCode === 401){
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Single Property
async function getSingleProperty(propertyId) {
  try {
    const signal = cancelPreviousRequest(`getSingleProperty`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getSingleProperty/${propertyId}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if(data?.statusCode === 401){
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}